<!--
 * @Author: 71
 * @Date: 2025-05-09 10:41:22
 * @LastEditTime: 2025-05-17 10:20:24
 * @LastEditors: 71
 * @Description: 
 * @FilePath: \aigoes-school-web\src\views\demo\EmotionMoodChartDemo.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <a-row>
    <a-card class="card-top">
      <a-col :span="24" class="title-1 title-margin flex-between">
        <div>学生人脸识别</div>
        <a-button type="reset" class="btn-reset" @click="resetImagesAndCurve">重置</a-button>
        <a-upload 
          name="files" 
          :showUploadList="false" 
          :multiple="true" 
          :headers="tokenHeader" 
          :action="importImagesUrl" 
          :beforeUpload="beforeUpload"
          >
          <a-button type="primary" @click="">上传照片</a-button>
        </a-upload>
      </a-col>
      <!-- <div class="images-box-container">
        <div class="images-box">
          <div class="images-box-item" v-for="(item, index) in 50" :key="'imagesbox1_' + index">
            <img src="https://picsum.photos/100/100" alt="" />
          </div>
        </div>
        <div class="images-box">
          <div class="images-box-item" v-for="(item, index) in 50" :key="'imagesbox2' + index">
            <img src="https://picsum.photos/100/100" alt="" />
          </div>
        </div>
      </div> -->
      <div class="images-box-container2" v-if="imagelist && imagelist.length > 0">
        <div class="images-box2">
          <div class="images-box-item2" v-for="(item, index) in imagelist" :key="'container2_imagesbox1_' + index">
            <span class="img-text">{{ index+1 }}</span>
            <span class="img-text-bottom error" v-if="item.recog===0">
              <a-icon class="bottom-icon" type="close"></a-icon>
              <span>错误</span>
            </span>
            <span class="img-text-bottom right" v-if="item.recog===1">
              <a-icon class="bottom-icon" type="check"></a-icon>
              <span>正确</span>
            </span>
            <img :src="getFileAccessHttpUrl(item.faceUrl)" alt="" />
          </div>
        </div>
      </div>
      <div class="images-box-container2" v-if="!imagelist || imagelist.length == 0">
        <div class="empty-data">
          <img style="width: 100px; height: 80px" :src="require('@assets/nodata.png')" alt="" />
          <div>暂无数据</div>
        </div>
      </div>
    </a-card>

    <a-card>
      <h3 class="title-1">学生心情图表</h3>
      <div class="salesCard">
        <LineChart71
          height="220px"
          :fields="chart.fields"
          :dataSource="chart.dataSource"
          :yAxisMultiple="1.15"
          :color="['#657ECB']"
          @mouseover-x="handleMouseOverX"
        />
      </div>
    </a-card>
  </a-row>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { uploadAction, postAction, getAction, getFileAccessHttpUrl } from '@/api/manage'
import LineChart71 from '@/components/echartZyz/components/LineChart71'
import { deleteAction } from '../../api/manage'

export default {
  name: 'EmotionMoodChartDemo',
  components: {
    LineChart71,
  },
  data() {
    return {
      formFiles: [], // 上传图片列表
      isUploaded: false, // beforeUpload会触发多次，所以标识
      imagelist: [], 
      // 用于保存轮询定时器
      pollingInterval: null, 
      //token header
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      chart: {
        tooltip:  { 
          trigger: 'axis',
          formatter: function(params) {
            // 检查是否是 markLine 的触发
            if (params && params.length>0 && params[0].componentType === 'series') {
              console.log('鼠标悬停在 markLine 上:', params);
            }
            // 返回默认的提示框内容
            return params[0].name + '<br/>' + params[0].seriesName + ': ' + params[0].value;
          }
        },
        fields:  ['心情指数'],
        dataSource: [],
      },
      // 请求url
      url: {
        importImagesUrl: 'demo/env/batchUploadFace',
        fetchImagesUrl: 'demo/env/getDemoEnvFaceList',
        getEmotionCurveUrl: 'demo/env/getEmotionCurve',
        pushMoodLampUrl: 'demo/env/pushMoodLamp',
        resetUrl: 'demo/env/reset'
      }
    }
  },
  created() {
    this.refresh();
  },
  computed: {
    importImagesUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importImagesUrl}`
    },
  },
  methods: {
    refresh() { 
      this.startPolling();
      this.getEmotionCurve();
    },
    resetImagesAndCurve() {
      deleteAction(this.url.resetUrl, {}).then(res => {
        if (res.success) {
          this.$message.success('重置成功')
          this.imagelist = [];
          this.chart.dataSource = [];
        } else {
          this.$message.warning(res.message)
        }
      });
    },
    beforeUpload(file, fileList) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        console.log('beforeUpload', '图片格式不对')
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        console.log('beforeUpload', '图片大小需要小于10M')
      }

      this.formFiles.push(file);
      console.log('this.formFiles.length', this.formFiles.length)
      console.log('fileList.length', fileList.length)
      if(this.formFiles.length === fileList.length) {
        this.uploadFiles(); // 自动触发上传
      }
      return false; // 阻止默认上传行为
    },
    uploadFiles(info) {
      const formData = new FormData();
      // 假设 this.files 是一个包含多个 File 对象的数组
      this.formFiles.forEach((file, index) => {
        formData.append('files', file, file.name); // 这里 'files' 是后端接收文件的字段名
      });
      uploadAction(this.importImagesUrl, formData)
        .then(response => {
          if (response.success) {
            this.$message.success('上传图片成功，等待情绪识别处理');
            this.formFiles = []; // 清空文件列表
            this.refresh();
          } else {
            this.$message.error('上传图片失败,');
            console.error(response.message);
          }
        })
        .catch(error => {
          this.$message.error(error);
          console.error(error);
        });
    },
    /* 轮询获取结果 */
    startPolling() {
      // 先清除可能存在的旧轮询
      if (this.pollingInterval) clearInterval(this.pollingInterval);

      // 定义轮询函数
      const polling = () => {
        getAction(this.url.fetchImagesUrl, {}).then(res => {
          if (res.success && res.result && res.result.length > 0) {
            this.$message.success('加载成功');
            console.log('图片列表71--：', res);
            this.imagelist = res.result;
            // 停止轮询
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
          }
        }).catch(err => {
          console.error('轮询请求出错:', err);
        });
      };

      polling();
      // 每隔3秒再执行一次轮询
      console.log('开始轮询71--：');
      this.pollingInterval = setInterval(polling, 3000); // 3秒一次
    },
    getFileAccessHttpUrl(url) {
      return getFileAccessHttpUrl(url);
    },
    getEmotionCurve() {
      getAction(this.url.getEmotionCurveUrl, {}).then(res => {
          if (res.success && res.result && res.result.length > 0) {
            const { dataSource } = convertChartData(res.result)
            this.chart.dataSource = dataSource
            // this.$message.success('加载成功');
            // 停止轮询
          }
        }).catch(err => {
          console.error('轮询请求出错:', err);
        });
    },
    handleMouseOverX(params) {
      const { seriesName, categoryName, dataValue } = params
      console.log(`${seriesName} - ${categoryName}: ${dataValue}`);
      getAction(this.url.pushMoodLampUrl,{emotion: dataValue}).then(res => {
        if (res.success) {
          this.$message.success('推送心情值到心情灯成功，值为：' + dataValue)
        } else {
          this.$message.warning(res.message);
        }
      })
    }
  }
}

/** 格式化图表数据 */
function convertChartData(datas) {
  let fields = [], dataSource = []
  if (datas && datas.length > 0) {
    datas.forEach(item => {
      const date = new Date(item.date)
      const month = String(date.getMonth() + 1).padStart(2, '0') // 月份补零
      const day = String(date.getDate()).padStart(2, '0')
      const shortDate = `${month}-${day}`
      dataSource.push({
        type: shortDate,
        '心情指数': item.happy
      })
    })
  }
  return { fields, dataSource }
}
</script>
<style scoped lang="less">
@import '~@assets/less/common.less';
.card-top {
  margin-bottom: 10px;

  .title-margin {
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .btn-reset {
    margin-left: auto;
    margin-right: 10px;
  }
  .images-box-container {
    width: 100%; /* 设置一个固定高度 */
    padding: 20px 10px;
    border-radius: 8px;
    overflow: hidden;
  }
  .images-box {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    overflow: scroll;

    .images-box-item {
      width: 100px;
      height: 100px;
      margin-right: 10px;
    }
  }
  
  .images-box-container2 {
    padding: 10px 0px;
    border-radius: 8px;
    border: 1px solid #F9F9F9;
    background: #fff;
    /* background: red; */
    overflow-y: auto; /* 启用水平滚动条 */
  }
  .images-box2 {
    max-height: 220px;
    width:100%;
    /* width: calc(50 * 110px); */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
    

    .images-box-item2 {
      flex: 0 0 100px; /* 每个图片的宽度 */
      width: 100px;
      height: 100px;
      margin-left: 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;

      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
      }
    }
    .img-text{
      position: absolute;
      top:0;
      left:50%;
      transform: translate(-50%, -0%); /* 调整偏移量 */
      color: white
    }
    .img-text-bottom {
      position: absolute;
      bottom:0;
      left:50%;
      transform: translate(-50%, -0%); /* 调整偏移量 */
      &.error {
        color: #EC2323;
        .bottom-icon{
          color: white;
          border-radius: 50%;
          background: #EC2323;
          margin-right: 5px;
        }
      }
      &.right {
        color: #21B5F1;
        .bottom-icon{
          color: white;
          border-radius: 50%;
          background: #21B5F1;
          margin-right: 5px;
        }
      }
    }
  }
  .empty-data {
    font-size: 16px; 
    text-align: center; 
    color: #ccc;
    transform: scale(0.8);
  }
}
</style>
